(function () {
  var print = document.querySelector('[data-print]');
  if (print) print.addEventListener('click', function () { window.print(); });

  var track = document.querySelector('[data-shop-track]');
  var bar = document.querySelector('[data-shop-progress]');
  if (track && bar) {
    var paint = function () {
      var max = track.scrollWidth - track.clientWidth;
      var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      bar.style.width = (visible * 100) + '%';
      bar.style.marginLeft = (pos * (1 - visible) * 100) + '%';
    };
    track.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    window.addEventListener('load', paint);
    paint();
  }

  var rotator = document.querySelector('[data-rotator]');
  if (!rotator) return;
  var items = rotator.querySelectorAll('[data-rotator-item]');
  var dots = rotator.querySelectorAll('.article__rotator-dots i');
  if (items.length < 2) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;
  var timer = null;

  function show(next) {
    var prev = items[current];
    prev.classList.remove('is-on');
    prev.classList.add('is-out');
    prev.setAttribute('aria-hidden', 'true');
    prev.setAttribute('tabindex', '-1');
    setTimeout(function () { prev.classList.remove('is-out'); }, 700);
    current = next;
    items[current].classList.add('is-on');
    items[current].removeAttribute('aria-hidden');
    items[current].removeAttribute('tabindex');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i === current);
  }

  function start() {
    if (reduce || timer) return;
    timer = setInterval(function () { show((current + 1) % items.length); }, 4500);
  }
  function stop() { clearInterval(timer); timer = null; }

  rotator.addEventListener('mouseenter', stop);
  rotator.addEventListener('mouseleave', start);
  rotator.addEventListener('focusin', stop);
  rotator.addEventListener('focusout', start);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  start();
})();
